import { Box, Typography } from "@mui/material";
import React, { Fragment, useMemo } from "react";
import { AccountInformation } from "../../../../api-types/account-information";
import { AccountType } from "../../../../api-types/common";
import { ProfileInformation } from "../../../../api-types/profile-information";
import { useUser } from "../../../state/hooks";
import { useResponsiveness } from "../../hooks/utils/useResponsiveness";
import { useScopedDowngradedStateValue } from "../../hooks/utils/useScopedDowngradedStateValue";
import { ProfilePicture } from "../../summary-profile";
import { ClientSelect } from "./select/ClientSelect";
import { ProfessionalSelect } from "./select/ProfessionalSelect";

type ProfileSummaryInfoProps = {
  accountInformation?: AccountInformation;
  profileInformation?: ProfileInformation;
  _id: string;
  isHovering?: boolean;
  isLoading?: boolean;
  onView?: () => void;
  hideActionButton?: boolean;
};

export const ProfileSummaryInfo: React.FC<ProfileSummaryInfoProps> = ({
  profileInformation,
  accountInformation,
  _id,
  isHovering,
  isLoading,
  onView,
  hideActionButton,
}) => {
  const { accountType } = useScopedDowngradedStateValue(useUser());

  const { isSmall, isMedium } = useResponsiveness();

  const hasFullName =
    accountInformation?.firstName || accountInformation?.lastName;

  const fullName = `${accountInformation?.firstName ?? ""} ${
    accountInformation?.lastName ?? ""
  }`;

  const profilePictureWidth = useMemo(() => {
    if (isSmall) {
      return 100;
    }

    if (isMedium) {
      return 140;
    }

    return 178;
  }, [isMedium, isSmall]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      rowGap={2}
      style={{
        cursor: "pointer",
      }}
    >
      <ProfilePicture
        profileInformation={profileInformation}
        width={profilePictureWidth}
        isHovering={isHovering}
        isLoading={isLoading}
        onClick={onView}
      />
      <Typography
        variant="subtitle2"
        style={{
          textAlign: "center",
          fontWeight: 550,
        }}
      >
        {hasFullName ? fullName : profileInformation?.username}
      </Typography>
      {!hideActionButton && (
        <Fragment>
          {accountType === AccountType.CLIENT ? (
            <ClientSelect professionalId={_id} />
          ) : (
            <ProfessionalSelect professionalId={_id} />
          )}
        </Fragment>
      )}
    </Box>
  );
};
